export default "__VITE_ASSET__DL4RcmUo__"